import InsertTeachingPeriodButtonContainer from './InsertTeachingPeriodButtonContainer';
export default InsertTeachingPeriodButtonContainer;
